import { BaseModel } from '~/shared/model'
import { isUnknownObject } from '~/shared/utils/guards'
import { fillOwnProperties } from '~/shared/utils/helpers'
import { ImageService } from '~/services/Misc/ImageService'

export default class ProfessionCardColourfulModel extends BaseModel {
  id: string = ''
  name: string = ''
  slug: string = ''
  description: string = ''
  'card_image': string = ''

  constructor(data: unknown) {
    super()
    if (isUnknownObject(data)) {
      fillOwnProperties(this, data)

      if (this.card_image) {
        this.card_image = new ImageService().cropImage(this.card_image, {})
      }
    }
  }
}
